import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LoaderProps {
  show: Boolean;
  className?: string;
}

function Loader({ show, className }: LoaderProps) {
  if (!show) return null;
  return (
    <div className={twMerge('flex items-center gap-2', className)}>
      <div
        data-testid="loader-dot"
        className="size-4 rounded-[10px] bg-neutral-light animate-loader-green"
      />
      <div
        data-testid="loader-dot"
        className="size-4 rounded-[10px] bg-primary-lightest animate-loader-purple"
      />
      <div
        data-testid="loader-dot"
        className="size-4 rounded-[10px] bg-primary-darkest animate-loader-blue"
      />
    </div>
  );
}

export default Loader;
